export default {"src":"/_next/static/media/white-room-names.46718e42.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};